import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function slugify(text: string): string {
  return String(text || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-/, '')
    .replace(/-$/, '')
    .slice(0, 120);
}

export function slugLengthValidator(minLength: number = 3): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const slug = slugify(control.value);

    if (slug.length < minLength) {
      return { slugLength: true };
    }

    return null;
  };
}

export function slugUniqueValidator(
  existingOfferings: Array<{ slug: string }>,
  currentSlug?: string | null
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const slug = slugify(control.value);
    const isDuplicate = existingOfferings.some(
      (offering) => offering.slug === slug && offering.slug !== currentSlug
    );

    if (isDuplicate) {
      return { slugDuplicate: true };
    }

    return null;
  };
}

export function slugValidator(
  existingOfferings: Array<{ slug: string }>,
  currentSlug?: string | null,
  minLength: number = 3
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const slug = slugify(control.value);

    if (slug.length < minLength) {
      return { slugLength: true };
    }

    const isDuplicate = existingOfferings.some(
      (offering) => offering.slug === slug && offering.slug !== currentSlug
    );

    if (isDuplicate) {
      return { slugDuplicate: true };
    }

    return null;
  };
}
